import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateSearchFields,
} from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import customClearOrderHistoryFilter from "@tKgpco/Store/Data/OrderHistory/Handler/CustomClearOrderHistoryFilters";

addToChainBefore(chain, DispatchUpdateSearchFields, props => {
    const getOrderHistoryParams = props.getState().pages.orderHistory.getOrdersParameter;
    props.dispatch(customClearOrderHistoryFilter({ clearOrderHistoryFilters: false, getOrderHistoryParams }));
});
